export const getNativeDeviceInfo = () => {
  let form = {};
  form.deviceId = '';
  form.deviceModel = '';
  form.osType = '';
  form.osVersion = '';
  form.appVersion = '';
  return form;
};
